'use client'

import { useEffect } from 'react'
import { useAuth } from '@hanzo/auth/service'
import { getCookie } from 'cookies-next'

const AuthListener = () => {
  const auth = useAuth()

  useEffect(() => {
    // Sites that do not share a login origin leave this unset; without it there
    // is nothing to ask, so asking would only fetch the string "undefined".
    const loginSite = process.env.NEXT_PUBLIC_LOGIN_SITE_URL
    if (!loginSite) return

    fetch(`${loginSite}/api/auth/get-auth-token`, {
      method: 'GET',
      credentials: 'include',
    })
    .then(response => response.json())
    .then((data: any) => {
      const token = data.reqToken
      if (!!token) {
        auth.loginWithCustomToken(token)
      }
    })
    .catch(() => { /* no shared session available */ })
  }, [auth])

  return ( <></> )
}

export default AuthListener
